<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Editar categoría</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <!-- Reference -->
              <b-form-group
                id="input-reference"
                class="col-3"
                label="Nombre"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  v-model="$v.form.reference.$model"
                  :state="validateState('reference')"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <!-- <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-name_' + lang"
                :label="'Nombre (' + languageNames[i] + ')'"
                :label-for="'name_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'name_' + lang"
                  v-model="$v.form['name_' + lang].$model"
                  :state="validateState('name_' + lang)"
                  :aria-describedby="'input-name_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-name_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>
            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-description_' + lang"
                :label="'Descripción (' + languageNames[i] + ')'"
                :label-for="'description_' + lang"
                class="col-3"
              >
                <b-form-textarea
                  :id="'description_' + lang"
                  v-model="$v.form['description_' + lang].$model"
                  :state="validateState('description_' + lang)"
                  :aria-describedby="'input-description_' + lang + '- feedback'"
                ></b-form-textarea>
                <b-form-invalid-feedback
                  :id="'input-description_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row> -->

            <b-button type="submit" variant="primary"
              >Guardar categoría</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  minLength,
  decimal,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

export default {
  name: 'AdminEmbroideryCategoriesEditScreen',
  props: ['id'],
  components: {},
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {
        required,
      },
    };

    this.languageCodes.map((x) => {
      // Only 'es' lang required
      // rules['name_' + x] = x === 'es' ? { required } : {};
      // rules['description_' + x] = x === 'es' ? { required } : {};
    });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      name: '',
      description: '',
      reference: '',

      error: {
        show: false,
        text: '',
      },
    };
    store.getLanguageCodes().map((x) => {
      // form['name_' + x] = '';
      // form['description_' + x] = '';
    });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),
      form: form,
    };
  },
  created() {
    actions.getEmbroideryCategoriesUnpaginated().then((x) => {
      actions.getEmbroideryCategory(this.id).then((z) => {
        const data = z.data;

        this.form.reference = data.reference;
        // this.form.name = data.name;
        // this.form.description = data.description;

        this.languageCodes.map((y) => {
          // this.form['name_' + y] = data['name_' + y];
          // this.form['description_' + y] = data['description_' + y];
        });
      });
    });
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {
        reference: this.form.reference,
      };

      this.languageCodes.map((x) => {
        // data['name_' + x] = this.form['name_' + x];
        // data['description_' + x] = this.form['description_' + x];
      });

      // data['name'] = this.form['name_' + this.languageCodes[0]];
      // data['description'] = this.form['description_' + this.languageCodes[0]];

      actions.patchEmbroideryCategory(this.id, data).then((x) => {
        this.$router.push({ name: 'AdminEmbroideryCategoriesScreen' });
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
